import { createSvg } from './../createSvg';

const Flash = ({ strokeWidth = 1.5 }): JSX.Element => {
    return <g id='contour'>
        <path
            d='M13.2366 2.084L5.39272 11.3541C4.84279 12.004 5.30475 13 6.15611 13H8.5C8.77614 13 9 13.2239 9 13.5V21.284C9 22.2139 10.1582 22.6403
            10.7612 21.9325L19.0958 12.1485C19.6488 11.4992 19.1874 10.5 18.3345 10.5H15.5C15.2239 10.5 15 10.2761 15 10V2.72994C15 1.79838 13.8383
            1.37286 13.2366 2.084Z'
            strokeWidth={strokeWidth}
        />
    </g>;
};

export default createSvg(
    Flash,
    'flash',
);
